export default "__VITE_ASSET__yiD9vVlU__"